import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers'
import { toBalanceString, toFiatString } from 'utils'

type BBABalanceProps = {
	daltons: number | bigint
	maximumFractionDigits?: number
	displayFiat?: boolean
	className?: string
}

const BBABalance = ({ daltons, maximumFractionDigits = 9, displayFiat = false, className }: BBABalanceProps) => {
	const { price } = useSelector((state: RootState) => state.price)

	const [fiatBalance, setFiatBalance] = useState<number>(0)

	useEffect(() => {
		if (price) {
			setFiatBalance(Number(daltons) * price.price)
		}
	}, [daltons, price, setFiatBalance])

	return (
		<p className={`flex gap-1 ${className}`}>
			<span>{`${toBalanceString(daltons, maximumFractionDigits)} BBA`}</span>
			{displayFiat && (
				<span className="text-small text-[#737373] dark:text-[#C9C9C9]">({toFiatString(fiatBalance)})</span>
			)}
		</p>
	)
}

export default BBABalance
